import React, { useEffect } from 'react';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const InsuranceType = ({
  options,
  isModEdit,
  onInsuranceTypeChange,
  setSelectedInsuranceType,
}: {
  options: any;
  isModEdit: boolean;
  onInsuranceTypeChange: (value: any) => void;
  setSelectedInsuranceType: (value: any) => void;
}) => {
  const { control, getValues, setValue, setError, clearErrors } = useFormContext();
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();
  const effectiveDateType: any = useWatch({ name: 'effectiveDateTypeId' });

  const handleValueChanged = value => {
    setValue('insuranceType', value);
    clearErrors('insuranceType');
    const selectedValue = options?.find(item => item.Description === value);
    setValue('insuranceTypeId', selectedValue?.ID ? parseInt(selectedValue?.ID) : '');
    onInsuranceTypeChange(value);
  };

  useEffect(() => {
    const value = options?.find(item => parseInt(item.ID) === getValues('insuranceTypeId'))?.Description;
    if (value) {
      setValue('insuranceType', value);
      clearErrors('insuranceType');
    } else {
      setError('insuranceType', {});
    }
  }, []);

  useEffect(() => {
    if (isUndoModal) {
      const value = options?.find(item => parseInt(item.ID) === getValues('insuranceTypeId'))?.Description;
      if (value) setValue('insuranceType', value);
      setSelectedInsuranceType(value);
      dispatch(placementModsAction.setInsuranceEffectiveType(effectiveDateType));
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [isUndoModal]);

  return (
    <>
      <Controller
        control={control}
        name={'insuranceTypeId'}
        rules={{
          required: true,
        }}
        render={({field: { onChange, value, ...rest } }) => {
          return (
            <FormInputDropdown
              name={'insuranceType'}
              label={`Type*`}
              require={true}
              standard={true}
              options={options ?? []}
              inputValue={getValues('insuranceType') ?? null}
              readOnly={!isModEdit}
              handleChange={e => {
                onChange(e);
                handleValueChanged(e.target.value);
              }}
            ></FormInputDropdown>
          );
        }}
      />
    </>
  );
};
